// This is work-around due to non properly working primeNG input...
export function detectDecimalSeparator(event: any): void {
  // Separator should be the German one - ','
  if (event.key === ',' && event.target.value && event.target.value.indexOf(',') === -1) {
    event.target.value += ',';
  } else if (event.key === '0') {
    event.preventDefault();
    const indexOfZero = event.target.selectionStart;
    const indexOfSeparator = event.target.value.indexOf(',');
    const separatorExists = indexOfSeparator > -1;
    const maxDecimalCharsReached = separatorExists && event.target.value.length - indexOfSeparator - 1 === 3;

    if (!separatorExists || indexOfZero <= indexOfSeparator || (!maxDecimalCharsReached && indexOfZero < indexOfSeparator + 3)) {
      event.target.value = `${event.target.value.substr(0, indexOfZero)}0${event.target.value.substr(indexOfZero)}`;
      event.target.setSelectionRange(indexOfZero + 1, indexOfZero + 1);
    }
  }
}
